/** The eight fields a refusal shows, and nothing else. */
export const DETAIL_FIELDS = [
    'id',
    'occurredAt',
    'action',
    'reason',
    'provider',
    'domain',
    'ipAddress',
    'traceId',
] as const;

export type DetailField = (typeof DETAIL_FIELDS)[number];

export type RefusalDetailFields = Record<DetailField, string>;

export const DETAIL_LABELS: Record<DetailField, string> = {
    id: 'Record',
    occurredAt: 'Time',
    action: 'Action',
    reason: 'Reason',
    provider: 'Provider',
    domain: 'Domain',
    ipAddress: 'IP address',
    traceId: 'Trace ID',
};

/**
 * What the detail panel shows: picked field by field, so whatever else a record
 * carries (an email, a token) has no way onto the screen. An absent field is a
 * dash rather than a missing row.
 */
export function toDetail(
    record: Partial<Record<DetailField, string | undefined>>,
): RefusalDetailFields {
    return Object.fromEntries(
        DETAIL_FIELDS.map((field) => [field, record[field] ?? '—']),
    ) as RefusalDetailFields;
}
